// ======================================================================
// File Name       : ContentDrillQuestionSortDiaLog
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Button, Col, ListGroup, ListGroupItem, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { SortableContainer, SortableElement, SortableHandle, arrayMove } from 'react-sortable-hoc';
import { saveDisplayOrderDrillQuestion, updateDisplayOrderStructureList } from '../../actions/ContentAction';
import ModalWrapper from '../../components/modal/ModalWrapper';

class ContentDrillQuestionSortDiaLog extends React.Component {
  constructor() {
    super();
    this.state = {};

    this.saveDisplayOrderDrillQuestion = this.saveDisplayOrderDrillQuestion.bind(this);
    this.onSortEnd = this.onSortEnd.bind(this);
    this.getCurrentPosOfActiveValue = this.getCurrentPosOfActiveValue.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.moveToTop = this.moveToTop.bind(this);
    this.moveUp = this.moveUp.bind(this);
    this.moveDown = this.moveDown.bind(this);
    this.moveToBot = this.moveToBot.bind(this);
    this.resetData = this.resetData.bind(this);
    this.hideModal = this.hideModal.bind(this);
  }

  handleSelect(index) {
    this.setState({
      activeValue: index,
    });
  }

  getCurrentPosOfActiveValue() {
    return this.props.editingStructureSecernIdList.indexOf(this.state.activeValue);
  }

  moveToTop() {
    if (isNaN(this.state.activeValue)) {
      return;
    }
    this.onSortEnd({
      oldIndex: this.state.activeValue,
      newIndex: 0,
    });
  }

  moveUp() {
    if (isNaN(this.state.activeValue)) {
      return;
    }
    const pos = this.state.activeValue;
    this.onSortEnd({
      oldIndex: pos,
      newIndex: pos - 1 < 0 ? 0 : pos - 1,
    });
  }

  moveDown() {
    if (isNaN(this.state.activeValue)) {
      return;
    }
    const length = this.props.editingStructureSecernIdList.length;
    const pos = this.state.activeValue;
    this.onSortEnd({
      oldIndex: pos,
      newIndex: pos + 1 >= length ? length - 1 : pos + 1,
    });
  }

  moveToBot() {
    if (isNaN(this.state.activeValue)) {
      return;
    }
    this.onSortEnd({
      oldIndex: this.state.activeValue,
      newIndex: this.props.editingStructureSecernIdList.length - 1,
    });
  }

  onSortEnd({ oldIndex, newIndex }) {
    const structureSecernIdList = arrayMove(this.props.editingStructureSecernIdList, oldIndex, newIndex);
    this.setState({
      activeValue: newIndex,
    });
    const { dispatch } = this.props;
    dispatch(updateDisplayOrderStructureList(structureSecernIdList));
  }

  saveDisplayOrderDrillQuestion() {
    const { dispatch } = this.props;
    dispatch(saveDisplayOrderDrillQuestion());
    this.hideModal();
  }

  hideModal() {
    const { dispatch } = this.props;
    dispatch(this.props.onDialogCancel);
    this.resetData();
  }

  resetData() {
    this.setState({
      activeValue: undefined,
    });
  }

  getNodeName(secernId) {
    const { bySecernId } = this.props.questionDrillListArr;
    if (!secernId || !bySecernId || !bySecernId[secernId]) {
      return '';
    }
    const { questionTitle } = bySecernId[secernId];
    return questionTitle;
  }

  getModalOption() {
    return {
      title: '問題の並び順を変更してください',
      footerBtns: [
        {
          name: 'キャンセル',
          onClick: this.hideModal,
          variant: 'default',
        },
        {
          name: 'OK',
          onClick: this.saveDisplayOrderDrillQuestion,
          variant: 'primary',
        },
      ],
    };
  }

  render() {
    const self = this;
    const structureNameList = this.props.editingStructureSecernIdList && this.props.editingStructureSecernIdList.map((item) => {
        return self.getNodeName(item);
    });

    return (
      <ModalWrapper {...this.getModalOption()} hideModal={this.hideModal} show={this.props.showModal} bodyClassName="setMinHeight">
        <Row>
          <Col sm={12}>
            <h3>
              {structureNameList && `問題グループ${this.props.editingGroupIndex}`}
            </h3>
          </Col>
        </Row>
        <Row className="margin-top-15">
          <Col sm={11}>
            <SortableList
              items={structureNameList}
              onSortEnd={this.onSortEnd}
              onClick={this.handleSelect}
              activeValue={this.state.activeValue}
              useDragHandle
              onBlur={() => this.setState({ activeValue: '' })}
            />
          </Col>
          <Col sm={1} className="course-sort-button">
            <Col className="fixed-button-sort">
              <Row>
                <Button variant="primary" className="btn-text-vertical" onClick={this.moveToTop}>
                  ↑最上位
                </Button>
              </Row>
              <Row>
                <Button
                  variant="primary"
                  className="btn-text-vertical  margin-top-10"
                  style={{ height: '70px' }}
                  onClick={this.moveUp}
                >
                  ↑
                </Button>
              </Row>
              <Row>
                <Button
                  variant="primary"
                  className="btn-text-vertical  margin-top-10"
                  style={{ height: '70px' }}
                  onClick={this.moveDown}
                >
                  ↓
                </Button>
              </Row>
              <Row>
                <Button
                  variant="primary"
                  className="btn-text-vertical margin-top-10"
                  onClick={this.moveToBot}
                >
                  最下位↓
                </Button>
              </Row>
            </Col>
          </Col>
        </Row>
      </ModalWrapper>
    );
  }
}

const DragHandle = SortableHandle(() =>
  (<span style={{ color: 'rgba(23, 23, 23, 0.58)' }}>
    <i className="bi bi-justify margin-right-15" />
  </span>),
);
const SortableItem = SortableElement(({ active, value, onClick }) =>
  (<ListGroupItem
    className="z-index-front display-table"
    onMouseDown={() => {
      onClick(value);
    }}
    active={active}
  >
    <DragHandle />
    <span className="break-text display-table-cell" style={{ width: '100%' }}>
      {value}
    </span>
  </ListGroupItem>),
);

const SortableList = SortableContainer(({ activeValue, items, onClick }) =>
  (<ListGroup>
    {items && items.map((value, index) =>
      (<SortableItem
        key={index}
        index={index}
        value={value}
        onClick={() => {
          onClick(index);
        }}
        active={index === activeValue}
      />),
    )}
  </ListGroup>),
);

const mapStateToProps = (state, ownProps) => {
  const {
    content: { questionDrillListArr, questionAddDialogArr, drillQuestionListStructure,
      editingStructureSecernIdList, editingGroupIndex
    },
  } = state;
  return { questionDrillListArr, editingStructureSecernIdList, questionAddDialogArr, drillQuestionListStructure, editingGroupIndex };
};

export default connect(mapStateToProps)(ContentDrillQuestionSortDiaLog);
